import {SINUP_EMAIL, TRACKING_DEVICE_TOKEN_KEY, USER_INFO, COUNTRY_CODE, CURRENCY_CODE} from "../../const/LocalStorage";
import {CURRENCY_COUNTRY_MAP, FALL_BACK_COUNTRY_CODE, FALL_BACK_CURRENCY} from "../../const/Pay";
import { getThinUuid } from "../../utils/common";
import {getCurrentQuestionnaireConfig, restoreQuestionnaireFormData} from "../questionnaire/registry";

export class User {
    constructor() {
        this.host = "https://app-service-stage.foodscannerai.com";
    }
    getBrowserInfo() {
        //browser
        let nAgt = navigator.userAgent;
        let browser = navigator.appName;
        let version = "" + parseFloat(navigator.appVersion);
        let nameOffset, verOffset; // Opera

        if ((verOffset = nAgt.indexOf("Opera")) != -1) {
            browser = "Opera";
            version = nAgt.substring(verOffset + 6);

            if ((verOffset = nAgt.indexOf("Version")) != -1) {
                version = nAgt.substring(verOffset + 8);
            }
        } // MSIE
        else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
            browser = "Microsoft Internet Explorer";
            version = nAgt.substring(verOffset + 5);
        } //IE 11 no longer identifies itself as MS IE, so trap it
        else if (browser == "Netscape" && nAgt.indexOf("Trident/") != -1) {
            browser = "Microsoft Internet Explorer";
            version = nAgt.substring(verOffset + 5);

            if ((verOffset = nAgt.indexOf("rv:")) != -1) {
                version = nAgt.substring(verOffset + 3);
            }
        } // Chrome
        else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
            browser = "Chrome";
            version = nAgt.substring(verOffset + 7);
        } // Safari
        else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
            browser = "Safari";
            version = nAgt.substring(verOffset + 7);

            if ((verOffset = nAgt.indexOf("Version")) != -1) {
                version = nAgt.substring(verOffset + 8);
            } // Chrome on iPad identifies itself as Safari. Actual results do not match what Google claims
            //  at: https://developers.google.com/chrome/mobile/docs/user-agent?hl=ja
            //  No mention of chrome in the user agent string. However it does mention CriOS, which presumably
            //  can be keyed on to detect it.

            if (nAgt.indexOf("CriOS") != -1) {
                //Chrome on iPad spoofing Safari...correct it.
                browser = "Chrome"; //Don't believe there is a way to grab the accurate version number, so leaving that for now.
            }
        } // Firefox
        else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
            browser = "Firefox";
            version = nAgt.substring(verOffset + 8);
        } // Other browsers
        else if (
            (nameOffset = nAgt.lastIndexOf(" ") + 1) <
            (verOffset = nAgt.lastIndexOf("/"))
        ) {
            browser = nAgt.substring(nameOffset, verOffset);
            version = nAgt.substring(verOffset + 1);

            if (browser.toLowerCase() === browser.toUpperCase()) {
                browser = navigator.appName;
            }
        }
        return {
            browser: browser,
            version: version,
        };
    }
    getLanguage() {
        return "en";
    }
    getCountryCode() {
        return localStorage.getItem(COUNTRY_CODE) || FALL_BACK_COUNTRY_CODE;
    }
    getUserInfo() {
        //{"userId":"11363486","vip":false,"token":"99AF3DD6CC9547A6B4B6E8271DDAEF95","uuid":"4e62bb34-f504-4516-b933-c912dc5eed9f"}
        let user = localStorage.getItem(USER_INFO);
        if (user) {
            user = JSON.parse(user);
            return user;
        }
        return undefined;
    }
    getUserId() {
        let user = this.getUserInfo();
        if (user && user.userId && user.userId.length > 0) {
            return user.userId;
        }
        return undefined;
    }
    getAccessToken() {
        let user = this.getUserInfo();
        if (user && user.token && user.token.length > 0) {
            return user.token;
        }
        return undefined;
    }
    getUserHeaders(){
        return {
            'Content-Type': 'application/x-www-form-urlencoded',
            "USER-ID": this.getUserId() || "",
            "ACCESS-TOKEN": this.getAccessToken() || "",
            VERSION: 1,
            "DEVICE-TYPE": 4,
        };
    }
    getSurveyFormData() {
        const questionnaireConfig = getCurrentQuestionnaireConfig();
        const savedData = localStorage.getItem(questionnaireConfig.localStorageKey);
        if (!savedData) {
            return;
        }
        try {
            return restoreQuestionnaireFormData(questionnaireConfig, JSON.parse(savedData));
        } catch (error) {
            console.error("Failed to parse questionnaire data from localStorage:", error);
            return;
        }
    }
    getSurveyEmail() {
        const formData = this.getSurveyFormData();
        return formData?.email;
    }
    getDeviceToken() {
        let token = localStorage.getItem(TRACKING_DEVICE_TOKEN_KEY);
        if (!token || token.length === 0) {
            token = getThinUuid();
            this.setDeviceToken(token);
        }
        return token;
    }

    setDeviceToken(token) {
        localStorage.setItem(TRACKING_DEVICE_TOKEN_KEY, token);
    }
    getDeviceInfo() {
        const browser = this.getBrowserInfo();
        return {
            device_type: 4,
            device_detail_info: {
                app_version: "1.0.0",
                adjust_id: "",
                apps_flyer_att: 0,
                language: this.getLanguage(),
                country_code: this.getCountryCode(),
                device_model: browser.browser || "",
                device_os: "1.0.0", //browser.version || "", ztodo
                ios_device_data: {},
            },
            device_token: this.getDeviceToken(),
        };
    }
    setUserInfo(data) {
        localStorage.setItem(USER_INFO, JSON.stringify(data));
    }
    getCurrencyFromCountryCode(code) {
        let currency = CURRENCY_COUNTRY_MAP[code];
        if (!currency) {
            return FALL_BACK_CURRENCY;
        }
        return currency;
    }
    getCurrencyCode() {
        let code = localStorage.getItem(CURRENCY_CODE);
        if (!code) {
            code = this.getCurrencyFromCountryCode(this.getCountryCode());
            let countryCode = localStorage.getItem(COUNTRY_CODE);
            if (countryCode && countryCode.length > 0) {
                localStorage.setItem(CURRENCY_CODE, code);
            }
        }
        return code || FALL_BACK_CURRENCY;
    }
    isGuestUser() {
        let user = this.getUserInfo();
        if (user && user.guest_user) {
            return true;
        }
        return false;
    }
    isVip() {
        let user = this.getUserInfo();
        if (user) {
            return user.vip || false;
        }
        return false;
    }
    setSinupEmail(email) {
        localStorage.setItem(SINUP_EMAIL, email);
    }
    getSinupEmail() {
        return this.email || localStorage.getItem(SINUP_EMAIL);
    }
}
